module.exports = __webpack_public_path__ + "static/media/3-Tall (1).4e71c1ff.mp3";